module.exports = __webpack_public_path__ + "static/media/navy_warning.b872bd9f.png";